import { withDefaults } from '@warp-drive/legacy/model/migration-support';

const RoleViewSchema = withDefaults({
  type: 'role-view',
  objectExtensions: ['role-view'],
  fields: [
    {
      kind: 'attribute',
      name: 'role',
    },
    {
      kind: 'attribute',
      name: 'relationshipType',
    },
    {
      kind: 'attribute',
      name: 'isActive',
    },
    {
      kind: 'attribute',
      name: 'createdAt',
    },
    {
      kind: 'attribute',
      name: 'updatedAt',
    },
    {
      kind: 'belongsTo',
      name: 'company',
      type: 'company',
      options: {
        async: false,
        inverse: null,
      },
    },
    {
      kind: 'belongsTo',
      name: 'user',
      type: 'user',
      options: {
        async: false,
        inverse: null,
      },
    },
  ],
});

export default RoleViewSchema;
